import { Box } from "@mui/material";
import { useEasierTheme } from "datalign-themes";
import React from "react";

const DatalignChip = ({
  filled = false,
  chipColour,
  textColour,
  content,
}: {
  filled?: boolean;
  chipColour?: string;
  textColour?: string;
  content: React.ReactNode;
}) => {
  const theme = useEasierTheme();
  return (
    <Box
      sx={{
        ml: 1,
        px: 1.5,
        py: 0.5,
        borderRadius: "16px",
        display: "inline-flex",
        alignItems: "center",
        lineHeight: 1.2,
        fontWeight: 475,
        maxWidth: "100%",
        textAlign: "center",
        color: textColour
          ? textColour
          : filled
            ? theme?.Colour.OnSecondary()
            : undefined,
        backgroundColor: filled
          ? (chipColour ?? theme?.Colour.Secondary())
          : undefined,
        border: `1px solid ${chipColour ?? theme?.Colour.Secondary()}`,
        ...(["FAF-nt", "nrdata-orig"].includes(
          process.env.REACT_APP_STYLING_THEME ?? "",
        )
          ? {
              border: `1px solid ${chipColour ?? "#E35205"}`,
              backgroundColor: filled ? (chipColour ?? "#E35205") : undefined,
            }
          : {}),
      }}
    >
      {content}
    </Box>
  );
};

export default DatalignChip;
